import React, { useEffect } from 'react';
import { Box, LoadingSpinner, PagePanel } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { goToPage } from '@epi-actions/navigation';
import { routerPaths } from '@epi-constants/routerPaths';
import { SuccessPageContent } from '@epi-pages/Onboarding/components/SuccessPageContent/SuccessPageContent';
import OnboardingStepper from '@epi-components/OnboardingStepper/OnboardingStepper';
import { SuccessPageNotification } from '@epi-pages/Onboarding/components/SuccessPageNotification/SuccessPageNotification';
import { useGetOnboardingSummaryQuery } from '@epi-api/onboardingSummary';
import { useGetCompanyBeneficiariesQuery } from '@epi-api/companyBeneficiaries';
import { onboardingActions } from '@epi-store/onboarding/onboarding.slice';
import { useOnboardingWizard } from '@epi-shared/hooks';

export const OnboardingFinished = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { data: summary, isLoading: isLoadingSummary } =
    useGetOnboardingSummaryQuery();
  const { data: beneficiariesData, isLoading: isLoadingBeneficiaries } =
    useGetCompanyBeneficiariesQuery();

  const {
    flags,
    isSuccess,
    isLoading: isLoadingFlags,
    handleGoOnboardingPayment
  } = useOnboardingWizard();

  const isSuccessPageAllowed =
    isSuccess && (flags?.isMoneyTransfered || flags?.isLoadInitiated);

  const handleOnboardingFinished = () => {
    dispatch(goToPage(routerPaths.home));
  };

  useEffect(() => {
    if (isSuccessPageAllowed) {
      dispatch(onboardingActions.setOnboardingInProgress(false));
    }
  }, [isSuccessPageAllowed]);

  if (isLoadingSummary || isLoadingBeneficiaries || isLoadingFlags) {
    return <LoadingSpinner />;
  }

  if (isSuccess && !(flags?.isMoneyTransfered || flags?.isLoadInitiated)) {
    handleGoOnboardingPayment();
    return null;
  }

  return (
    <Box>
      <OnboardingStepper />
      <PagePanel
        title={t('components.onboarding.success_page.title')}
        footer={{
          submitText: t('components.onboarding.buttons.alright'),
          onSubmit: handleOnboardingFinished
        }}
      >
        <Box display="flex" flexDirection="column" gap={3}>
          <SuccessPageNotification
            variant={'benefits'}
            numberOfEmployees={beneficiariesData?.beneficiaries.length}
          />
          {summary?.displayMerchantToolSection && (
            <SuccessPageNotification variant={'merchant'} />
          )}
          {summary?.benefitsLeftUnloaded && (
            <SuccessPageNotification variant={'unfinished'} />
          )}
          <SuccessPageContent />
        </Box>
      </PagePanel>
    </Box>
  );
};
